<template>
	<div>
		<b-form-file
			ref="proxyValue"
			v-model="proxyValue"
			:state="state"
			:placeholder="fieldInfo.placeholder"
			:drop-placeholder="fieldInfo.dropPlaceholder"
			:browse-text="fieldInfo.browseText"
			@change="fileChange"
			:disabled="!active"
		></b-form-file>
		<br />
		<b-button size="sm" @click="removeFile">{{ $t("components.kInputFile.removeFile") }}</b-button>

		<b-form-invalid-feedback :id="`${fieldInfo.name}-feedback`">
			{{ errors[fieldInfo.name] }}
		</b-form-invalid-feedback>
	</div>
</template>
<script>
export default {
	props: {
		state: {
			type: Boolean,
			default: null
		},
		value: {
			type: [String, File]
		},
		fieldInfo: {
			type: Object
		},
		errors: {
			type: Object
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		}
	},
	data() {
		return { active: true };
	},
	computed: {
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", this.fieldInfo.name);
			}
		}
	},
	methods: {
		fileChange: function (e) {
			let file = e.target.files[0];
			this.$emit("fileChange", file);
		},
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		},
		removeFile: function () {
			this.$refs["proxyValue"].reset();
		}
	},

	beforeMount() {
		if (typeof this.isActive == "function") this.active = this.isActive(null);
		else this.active = this.isActive;
	}
};
</script>

<style>
btn-secondary {
	color: #666666;
	background-color: #d6d6d6;
	border-color: #d6d6d6;
}
</style>
